// C:\laragon\www\SMARTCAT\smartcat-v4-frontend\src\services\dashboards\mynotificationService.js
import apiHeader from "@/helpers/apiHeader";

const myNotificationService = {
  list(page = 1, params = {}) {
    return apiHeader.get(`dashboard/notification?page=${page}`, { params });
  },
  navbar() {
    return apiHeader.get(`navbar/notification`);
  },
  get(id) {
    return apiHeader.get(`notification/${id}`);
  },
  detail(id) {
    return apiHeader.get(`dashboard/notification/${id}`);
  },
  read(id) {
    return apiHeader.patch(`navbar/notification/${id}/read`);
  },
  readAll() {
    return apiHeader.patch(`navbar/notification/read-all`);
  },
};

export default myNotificationService;
